import * as React from "react"

import { cn } from "@/lib/utils"

// Fase 1 UI Pro Max:
// - h-10 min-h-[44px] para respetar touch target en mobile.
// - Ring naranja al focus (usa --ring token, ya es orange).
// - transition tokens fast + ease-out.
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 min-h-[44px] w-full rounded-md border border-input bg-transparent px-3 py-1",
        "text-base shadow-sm",
        "transition-[border-color,box-shadow] duration-fast ease-out-atl",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
